import React, { useState } from "react";
import "./Message.scss";
import DashboardHeader from "../../../components/header/DashboardHeader";
import ChatList from "./ChatList";
import MessageBox from "./MessageBox";
import { useParams } from "react-router";

const Message = ({ chatType }) => {
  const { chatId, tab } = useParams();
  const [selectedChatType, setSelectedChatType] = useState(tab || "GROUP");
  const [selectedChat, setSelectedChat] = useState({});
  const [chatUserList, setChatUserList] = useState(false);
  const [groupDetails, setGroupDetails] = useState({});
  const [memberDetails, setMemberDetails] = useState("");

  const [isReplay, setIsReplay] = useState(false);
  const [selectedReplyData, setSelectReplyData] = useState({});
  const [attachment, setAttachment] = useState({
    attachment: "",
    type: "",
    url: "",
  });
  const [inputData, setInputData] = useState({ message: "", type: "" });
  // console.log('tab', { tab, chatId, chatType })
  // console.log('selectedChat', selectedChat)
  const tabsName =
    chatType === "GROUP"
      ? "Group Chat"
      : chatType === "MEMBER"
      ? "Member Chat"
      : "chat";
  return (
    <>
      <DashboardHeader title={tabsName || "Message"} />
      <div className="dashboard_pages">
      <div className={`parent_msg ${chatUserList ? "showList" : ""}`}>
        <ChatList
          selectedChatType={selectedChatType}
          setSelectedChatType={setSelectedChatType}
          setSelectedChat={setSelectedChat}
          selectedChat={selectedChat}
          chatId={chatId}
          tab={tab}
          groupDetails={groupDetails}
          setMemberDetails={setMemberDetails}
          setGroupDetails={setGroupDetails}
          onClick={() => setChatUserList(false)}
          setIsReplay={setIsReplay}
          setSelectReplyData={setSelectReplyData}
          chatType={chatType}
          attachment={attachment}
          setAttachment={setAttachment}
          inputData={inputData}
          setInputData={setInputData}
        />
        <MessageBox
          selectedChat={selectedChat}
          selectedChatType={selectedChatType}
          setSelectedChat={setSelectedChat}
          showChatUsers={() => setChatUserList(!chatUserList)}
          chatId={chatId}
          memberDetails={memberDetails}
          setGroupDetails={setGroupDetails}
          isReplay={isReplay}
          setIsReplay={setIsReplay}
          selectedReplyData={selectedReplyData}
          setSelectReplyData={setSelectReplyData}
          chatType={chatType}
          attachment={attachment}
          setAttachment={setAttachment}
          inputData={inputData}
          setInputData={setInputData}
        />
      </div>
      </div>
    </>
  );
};

export default Message;
